"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppProviders;

var _preact = require("preact");

var _globals = require("@insided/shared/utils/globals");

var _context = require("@insided/deprecated-libs/translationsUtils/context");

var _userContext = require("../../server-middleware/userContext");

var _CurrentPageContext = require("../../pages/utils/CurrentPageContext");

var _PageUnloadContext = _interopRequireDefault(require("@insided/shared/services/PageUnloadContext"));

var _BrandConfigContext = _interopRequireDefault(require("@insided/shared/services/BrandConfigContext"));

var _AppStateContext = require("@insided/shared/services/AppStateContext");

var _ModuleEnablementContext = require("@insided/shared/services/ModuleEnablementContext");

function AppProviders(_ref) {
  var children = _ref.children,
      modules = _ref.modules,
      translationContext = _ref.translationContext,
      userContext = _ref.userContext,
      pageContext = _ref.pageContext,
      userPermissions = _ref.userPermissions,
      appState = _ref.appState;
  return (0, _preact.h)(_AppStateContext.AppStateProvider, {
    appState: appState
  }, (0, _preact.h)(_globals.ModulesContext.Provider, {
    value: modules
  }, (0, _preact.h)(_context.TranslationsProvider, translationContext, (0, _preact.h)(_userContext.CurrentUserContext.Provider, {
    value: userContext
  }, (0, _preact.h)(_CurrentPageContext.CurrentPageContext.Provider, {
    value: pageContext
  }, (0, _preact.h)(_userContext.UserPermissionContext.Provider, {
    value: userPermissions
  }, (0, _preact.h)(_PageUnloadContext.default, null, (0, _preact.h)(_BrandConfigContext.default, null, (0, _preact.h)(_ModuleEnablementContext.ModuleEnablementProvider, null, children)))))))));
}